import { z } from 'zod';
import { CustomErrorParams, CustomErrorType } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const fieldNames = {
    reason: 'reason',
    creditNoteCounterId: 'creditNoteCounterId',
} as const;

export const creditNoteCounterIdSchema = (creditNoteCounterRequired: boolean) =>
    z
        .string()
        .optional()
        .refine((value) => (creditNoteCounterRequired ? !!value : true), {
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.ValidateRequired,
            } satisfies CustomErrorParams,
        });

export const createValidationSchema = (creditNoteCounterRequired: boolean) =>
    z.object({
        [fieldNames.reason]: z.string().min(1).default(''),
        [fieldNames.creditNoteCounterId]: creditNoteCounterIdSchema(creditNoteCounterRequired),
    });

export type FormValues = z.infer<ReturnType<typeof createValidationSchema>>;
